export { default as RegistryOnboardVariationTemplate } from './RegistryOnboardVariationTemplate/RegistryOnboardVariationTemplate';
export { default as UniversalRegistrySection } from './UniversalRegistrySection/UniversalRegistrySection';
export { default as ProductCategoriesSection } from './ProductCategoriesSection/ProductCategoriesSection';
export { default as BrandsSection } from './BrandsSection/BrandsSection';



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/RegistryContainer/RegistryOnboardContainer/components/index.js